var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.125H9.0075M6.15 16.5H11.85C12.6901 16.5 13.1102 16.5 13.431 16.3365C13.7132 16.1927 13.9427 15.9632 14.0865 15.681C14.25 15.3602 14.25 14.9401 14.25 14.1V3.9C14.25 3.05992 14.25 2.63988 14.0865 2.31902C13.9427 2.03677 13.7132 1.8073 13.431 1.66349C13.1102 1.5 12.6901 1.5 11.85 1.5H6.15C5.30992 1.5 4.88988 1.5 4.56902 1.66349C4.28677 1.8073 4.0573 2.03677 3.91349 2.31902C3.75 2.63988 3.75 3.05992 3.75 3.9V14.1C3.75 14.9401 3.75 15.3602 3.91349 15.681C4.0573 15.9632 4.28677 16.1927 4.56902 16.3365C4.88988 16.5 5.30992 16.5 6.15 16.5ZM9.375 13.125C9.375 13.3321 9.20708 13.5 9 13.5C8.79292 13.5 8.625 13.3321 8.625 13.125C8.625 12.9179 8.79292 12.75 9 12.75C9.20708 12.75 9.375 12.9179 9.375 13.125Z",
    stroke: "#111111",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileicon);
export default __webpack_public_path__ + "static/media/mobileicon.e6e57563169093a52f214b2ab862fc70.svg";
export { ForwardRef as ReactComponent };